module.exports = __webpack_public_path__ + "static/media/varais-4.6c9ba619.jpg";